import Vue from 'vue'
import Hammer from 'hammerjs'
import VModal from 'vue-js-modal'
import Snackbar from 'vuejs-snackbar'
import App from './App.vue'
import { router } from './router'
import { store } from './store'
import './plugins/axios'

Vue.config.productionTip = false

Vue.use(VModal, { dynamic: true })

Vue.component('snackbar', Snackbar)

Vue.directive('swipeleft', {
  bind: function (el, binding) {
    if (typeof binding.value === 'function') {
      const mc = new Hammer(el, {
        touchAction: 'pan-y',
      })
      mc.on('swipeleft', binding.value)
    }
  },
})

Vue.directive('swiperight', {
  bind: function (el, binding) {
    if (typeof binding.value === 'function') {
      const mc = new Hammer(el, {
        touchAction: 'pan-y',
      })
      mc.on('swiperight', binding.value)
    }
  },
})

initVueSystem()

async function initVueSystem() {
  await store.dispatch('clientInit')
  // 앱 공지 웹뷰(/appnotice·/appnotice_m)는 상품·플랜 데이터를 쓰지 않는다 —
  // 수 MB 짜리 preload-data 응답을 기다리느라 첫 화면이 늦어지지 않게 건너뛴다.
  if (!/^\/appnotice(_m)?\/?$/.test(location.pathname)) {
    try {
      await store.dispatch('preloadData')
    } catch (err) {
      // serve/preload-data 장애 시에도 앱을 마운트한다. preloadData는 빠른 초기
      // 로드일 뿐이고 goodsList·goodsDetail은 아래 fetchGoodsList/fetchGoodsDetail
      // (Firestore 직접)이 재적재하며, planInfo는 preloadData 내부에서 RTDB로 폴백한다.
      // (이 가드가 없어 2026-09-08~11 serve 장애 때 웹 전면이 백지가 됐다.)
      console.warn(
        '[init] preloadData 실패 — Firestore/RTDB 폴백으로 계속:',
        err,
      )
    }
  }

  store.dispatch('csrfToken')
  store.dispatch('getServerTime')
  store.dispatch('fetchGoodsList')
  store.dispatch('fetchGoodsDetail')
  store.dispatch('getCategoryList')
  store.dispatch('loadAvailableGoodsList')

  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
}
